// store/modules/favoriteList.js
import FavoriteListService from "@/services/favoriteList.service";

export default {
  namespaced: true,
  state: {
    lists: [],
    activeId: null,
  },
  mutations: {
    SET_LISTS(state, lists) {
      state.lists = lists;
    },
    SET_ACTIVE(state, id) {
      state.activeId = id;
    },
    ADD_LIST(state, list) {
      state.lists.push(list);
    },
    UPDATE_LIST(state, updated) {
      const i = state.lists.findIndex((l) => l.id === updated.id);
      if (i !== -1) state.lists.splice(i, 1, updated);
    },
    REMOVE_LIST(state, id) {
      state.lists = state.lists.filter((l) => l.id !== id);
    },
  },
  actions: {
    async fetchLists({ commit }) {
      console.log("[favoriteList] 🔄 fetchLists() start");

      const { data } = await FavoriteListService.getFavoriteLists();
      console.log("[favoriteList] ↩️ lists:", data.data);

      commit("SET_LISTS", data.data);
    },

    setActive({ commit }, id) {
      console.log("[favoriteList] ➡️ setActive(", id, ")");
      commit("SET_ACTIVE", id);
      console.log("[favoriteList]    activeId now =", id);
    },

   
    async createList({ commit, dispatch }, name) {
      // 1) call the API
      const { data } = await FavoriteListService.addFavoriteList({ name });
      // 2) add it to the vuex state
      commit("ADD_LIST", data.data);
      // 3) make the newly created list the active one
      commit("SET_ACTIVE", data.data.id);
      // 4) fetch its favorites immediately
      await dispatch("favorite/fetchFavorites", data.data.id, { root: true });
    },
    async updateList({ commit, state, dispatch }, { id, name }) {
      const { data } = await FavoriteListService.updateFavoriteList(id, {
        name,
      });
      commit("UPDATE_LIST", data.data);
      // if you're editing the active list's name, keep it active
      if (state.activeId === id) {
        commit("SET_ACTIVE", id);
      }
    },

    async deleteList({ commit, state, dispatch }, id) {
      await FavoriteListService.removeFavoriteList(id);
      commit("REMOVE_LIST", id);

      // if we just deleted the active list, pick a new one
      if (state.activeId === id) {
        const next = state.lists[0]?.id || null;
        commit("SET_ACTIVE", next);
        if (next) {
          // reload its favorites if needed
          dispatch("favorite/fetchFavorites", next, { root: true });
        }
      }
    },
  },
  getters: {
    activeList: (s) => s.lists.find((l) => l.id === s.activeId),
    activeId: (s) => s.activeId,
  },
};
